import w1 from "../window/w1.jpeg"
import w2 from "../window/w2.jpeg"
import w3 from "../window/w3.jpeg"
import w4 from "../window/w4.jpeg"
import w5 from "../window/w5.jpeg"
import w6 from "../window/w6.jpeg"
import w7 from "../window/w7.jpeg"
import w8 from "../window/w8.jpeg"
import w9 from "../window/w9.jpeg"
import w10 from "../window/w10.jpeg"
import w11 from "../window/w11.jpeg"
import w12 from "../window/w12.jpeg"
import w13 from "../window/w13.jpeg"
import w14 from "../window/w14.jpeg"
import w15 from "../window/w15.jpeg"
import w16 from "../window/w16.jpeg"
import w17 from "../window/w17.jpeg"
import w18 from "../window/w18.jpeg"
import w19 from "../window/w19.jpeg"
import w20 from "../window/w20.jpeg"
import w21 from "../window/w21.jpeg"
import w22 from "../window/w22.jpeg"
import w23 from "../window/w23.jpeg"
import w24 from "../window/w24.jpeg"



function Windows() {
  return (

    <div class="container">
      <h1>Windows Work</h1>
      <h4>A glimpse of our craftsmanship through some of our completed projects.</h4>

      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
        <div class="col">
          <div class="card shadow-sm">
            <img src={w1} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w2} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w3} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w4} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w5} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w6} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w7} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w8} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w9} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w10} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w11} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w12} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>

        <div class="col">
          <div class="card shadow-sm">
            <img src={w13} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w14} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w15} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w16} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w17} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w18} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w19} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w20} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w21} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w22} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w23} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={w24} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>

      </div>
      <p><a class="btn btn-success" href="https://www.instagram.com/invites/contact/?igsh=1izl3bvvj2uj3&utm_content=zvshzkp">View more &raquo;</a></p>
      <hr class="featurette-divider" /></div>

  );
}

export default Windows;
